'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UIModal from 'UIComponents/dialog/UIModal';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import TrackDeprecatedDescription from '../../TrackCard/TrackDeprecatedDescription';
import H2 from 'UIComponents/elements/headings/H2';

const TrackDeprecatedModal = ({
  trackId,
  message,
  cta
}) => /*#__PURE__*/_jsxs(UIModal, {
  "data-test-id": "track-deprecated-modal",
  size: "auto",
  children: [/*#__PURE__*/_jsx(UIDialogHeader, {
    children: /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.tracks.deprecations.deprecationNoticeTitle"
      })
    })
  }), /*#__PURE__*/_jsx(UIDialogBody, {
    children: /*#__PURE__*/_jsx(TrackDeprecatedDescription, {
      cta: cta,
      message: message,
      trackId: trackId
    })
  }), /*#__PURE__*/_jsx(UIDialogFooter, {
    align: "center",
    children: /*#__PURE__*/_jsx(UIRouterButton, {
      to: "/",
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.heading.backToTracks.link"
      })
    })
  })]
});

TrackDeprecatedModal.propTypes = {
  cta: PropTypes.string,
  message: PropTypes.string,
  trackId: PropTypes.string.isRequired
};
export default TrackDeprecatedModal;